import { IFilter, round, IPeerGroupTabsProps, IVisualizationState } from "../../lib/http";
import * as React from 'react'
import { Panel } from "react-bootstrap";
import * as ReactHighcharts from 'react-highcharts'

export class PercentFoundationsReceived extends React.Component<IPeerGroupTabsProps, IVisualizationState> {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: '',
    loading: false,
    average: [],
  }

  componentDidMount() {
    this.loadSeries(this.props.filters)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel || prevProps.data.length !== this.props.data.length) {
      this.setState({ filters: this.props.filters, data: this.props.data }, () => {
        this.loadSeries(this.props.filters)
      })
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state

    const currentSet = data.find(dataPoint => dataPoint.filterId === filters.assetLevel)

    const title = currentSet ? currentSet['IncCon_T_B_IncomingPercent'] : ''
    const subtitle = currentSet ? currentSet['IncCon_T_V7_Vis7Title'] : ''
    const noLabel = currentSet ? currentSet['IncCon_T_V6_LabelNo'] : ''
    const yesLabel = currentSet ? currentSet['IncCon_T_V6_LabelYes'] : ''
    const noValue = currentSet ? parseFloat(round(currentSet['IncCon_N_V6_IncPctNo'] * 100.0, 1)) : 0
    const yesValue = currentSet ? parseFloat(round(currentSet['IncCon_N_V6_IncPctYes'] * 100.0, 1)) : 0

    const series = [{
      name: subtitle,
      //name: "Percent Receiving Contributions",
      innerSize: '75%',
      data: [{ color: '#2F75B5', name: yesLabel, y: yesValue }, { color: '#BDD7EE', name: noLabel, y: noValue }]
    }]

    this.setState({ title, series })

  }

  getChartConfig(series) {
    const title = "Percentage Receiving Incoming Contributions";
    // const title = series[0]['name']
    return {
      chart: { type: 'pie' },
      title: {
        text: title
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
          },
          showInLegend: true
        }
      },
      legend: { enabled: false },
      credits: { enabled: false },
      series
    }
  }

  render() {
    const { title, series, loading } = this.state
    return (
      <Panel>
        <div className="panel-heading text-center">
          {title}{loading && <i className="fa fa-cog fa-spin"></i>}
        </div>
        <div className="panel-body">
          <ReactHighcharts config={this.getChartConfig(series)} ref="chart" />
        </div>
      </Panel>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/IncomingContributions/PercentFoundationsReceived/index.tsx